import { Link } from "react-router-dom";
import type { Flag } from "@mosaic/shared";
import { FLAG_LABELS } from "@mosaic/shared";
import { filingHref } from "../lib/citations.js";
import { severityClass } from "../lib/format.js";

/**
 * Findings, with their evidence attached. The API drops any flag whose evidence is
 * missing, so an empty `evidence` array never reaches here.
 *
 * `method` is shown because a rule-derived finding and an LLM-derived one deserve
 * different amounts of trust.
 */
export function FlagList({
  flags,
  onDismiss,
}: {
  flags: Flag[];
  onDismiss: (flagId: string) => void;
}) {
  if (flags.length === 0) return null;

  return (
    <>
      <div className="sechd">Findings</div>
      {flags.map((flag) => {
        const label = FLAG_LABELS[flag.kind];
        return (
          <article className="evid" key={flag.id}>
            <div className="lb">
              <span>{label?.title ?? flag.kind.replace(/_/g, " ")}</span>
              <span className={`sev ${severityClass(flag.severity)}`}>{flag.severity}</span>
              <span className="sev">{flag.method}</span>
            </div>
            <p className="sum">{flag.summary}</p>
            {flag.evidence.map((e, i) => (
              <div key={`${e.documentId}-${e.charStart}-${i}`}>
                <blockquote>“{e.quote}”</blockquote>
                <div className="row">
                  <span className="who">
                    <Link
                      to={filingHref(e.accession, e)}
                    >
                      {e.accession}
                    </Link>
                    {` @${e.charStart.toLocaleString()}`}
                  </span>
                  {i === 0 && (
                    <button className="iconbtn" onClick={() => onDismiss(flag.id)}>
                      Dismiss
                    </button>
                  )}
                </div>
              </div>
            ))}
          </article>
        );
      })}
    </>
  );
}
